
function MSAssignment() {
    /// <summary>
    /// This object provides js functions for the Widget.Assigment.* <br/>
    /// <br/>
    /// Author: ARF<br />
    /// Date: 11.5.2016<br />
    /// Copyright ©: EUDT GmbH 2016 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.1 - 10.08.2016   (MWI)                                      *<br />
    /// **********************************************************************<br />
    /// * -added functions addAssignmentItemSpecifics, loadFirstInList and addSpecificClickHandler               *<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 11.5.2016                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
  
}

MSAssignment.prototype = new vcTemplate();


MSAssignment.prototype.init = function () {
    /// <summary>
    /// This function inits the menu click handler. 
    /// </summary>
    var me = this;
    var id;
    try {
        if (me.error) {return false;}
       
        me.showInfo("", "", false);
        me.visual.find('.vc-list').height(me.visual.height() - 25);
        //alert('d');
        
        //console.log(me.visual.find("#divTarget"));
        ////init the filter events
        me.initFilterInput(me.visual.find("#divEntry #txtFilter"), me.visual.find("#divEntry"));
        me.initFilterInput(me.visual.find("#divSource #txtFilter"), me.visual.find("#divSource"));
        me.initFilterInput(me.visual.find("#divTarget #txtFilter"), me.visual.find("#divTarget"));
        me.visual.find('#divEntry').off('click', '.vc-list-item').on('click', '.vc-list-item', function (e) {
            id = parseInt($(this).attr("data-id"), 10);
            me.visual.find("#divEntry .vc-list-item").removeClass("button-active");
            $(this).addClass("button-active");
            me.loadItems(id);
            e.stopPropagation();
        });

        me.loadFirstInList();
        me.addspecificClickHandler();

        if (me.assID !== -1) {
            me.loadItems(me.assID);
        }


        me.visual.find(".btn-select-all").off("click").on("click", function() {
            $.each($(this).siblings(".connect").find("li:visible"), function () { me.manualUpdate($(this)); });
        }).button();


        return true;
    } catch (ex) {
        me.writeError('init', ex);
        return false;
    }

};

MSAssignment.prototype.loadFirstInList = function() {
    /// <summary>
    /// If implemented this function loads the first item in the selection list
    /// </summary>
};

// ReSharper disable once UnusedParameter
MSAssignment.prototype.addAssignmentItemSpecifics = function (row) {
    /// <summary>
    /// This function inits the assigment specific icons if implemented
    /// </summary>
    ///<param name='row'> a row object to add the item </param>
    
    return "";
};
MSAssignment.prototype.addspecificClickHandler = function() {
    /// <summary>
    /// This function inits assignment specific click handler
    /// </summary>

};
MSAssignment.prototype.reportValid = function() {
    /// <summary>
    /// This function states if the report is valid
    /// </summary>

};
MSAssignment.prototype.loadItems = function (id) {
    /// <summary>
    /// This function loads all entries for the selected item and fills the sortable lists 
    /// </summary>
    var me = this;
    var sTmp;
    try {
        if (me.error) { return false;}
            me.assID = id;
            me.visual.find("#lstSource").html(me.vcC.getLoadingIcon());


            window.VisualCoreService.getData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, me.parameter, me.signalParameter, me.deviceType, me.langid, JSON.stringify({ 'type': 1,'LoggerId':me.blid, 'id': id, 'assID': me.assID }),
            function (result) {
 
                if (result === null) {
                    me.showMessage(me.resources.err_loadData, true);
                    return false;
                }
                $("#" + me.visual[0].id + " #lstSource,#" + me.visual[0].id + " #lstTarget").html("");
                if (result.rows === null) {
                    $("#" + me.visual[0].id + " #lstSource").html("<div class='note' style='margin:0 3px 0 3px'>" + me.resources.noEntriesExist + "</div>");
                    return false;
                }

                for (var i = 0; i < result.rows.length; i++) {
                    sTmp = "<li class='vc-list-item ui-widget-content";
                    if (result.rows[i].active === false) { sTmp += " inactive" }


                    if (result.rows[i].delete === false) { sTmp += " notDelete" }

                    if (result.rows[i].staff === true) { sTmp += " staff" }
                    sTmp += "' data-id='" + result.rows[i].id + "'>";
                    sTmp += me.addAssignmentItemSpecifics(result.rows[i]);
                    if (result.rows[i].delete === false) { sTmp += "<i class='fa fa-ban'></i> " }
                    if (result.rows[i].staff) { sTmp += "<i class='fa fa-users'></i> " }

                    if (result.rows[i].prefix.length > 0) {
                        sTmp += result.rows[i].prefix + ' - ' + result.rows[i].name;
                    } else {
                        sTmp += result.rows[i].name;
                    }
                    sTmp += "</li>";
                    if (result.rows[i].foundid === null) {
                        me.visual.find("#lstSource").append(sTmp);
                    } else {
                        me.visual.find("#lstTarget").append(sTmp);
                    }
                }
               // init the refilled sortable source and target lists

                me.initSortable();
                me.filter(me.visual.find("#divSource #txtFilter"), me.visual.find("#divSource"));
                me.filter(me.visual.find("#divTarget #txtFilter"), me.visual.find("#divTarget"));
                me.reportValid();
                return true;
            });

        return true;
    } catch (ex) {
        me.writeError('loadItems', ex);
        return false;
    }

};

MSAssignment.prototype.initSortable = function () {
    /// <summary>
    /// Inits the list as sortable list - items can get sorted by drag and drop.<br/>
    /// After each drag the item gets updated.
    /// </summary>
    var me = this;
    try {
        if (me.error) {return false;}
        if (me.mobile) { return true;}
      
        me.visual.find("#lstSource,#lstTarget").sortable({
            connectWith: ".connect",
            tolerance: 'pointer', cursor: 'move', placeholder: "lstPlaceholder",
            update: function (e, ui) {
                me.manualSorting(e);
             
                if (ui.sender !== null) {
                  
                    if (typeof (ui.item[0].attributes["data-id"]) !== "undefined") {
                        me.update(ui.sender[0].id, ui.item[0].attributes["data-id"].value);
                   
                    }
                }
            }
        }).disableSelection();

        me.visual.find(".connect").off("dblclick", ".vc-list-item").on('dblclick', ".vc-list-item",
            function () {
                return me.manualUpdate($(this));
            });


        return true;
    } catch (ex) { me.writeError('initSortable', ex);return false;}

};


MSAssignment.prototype.manualSorting = function (obj) {
 
};

MSAssignment.prototype.manualUpdate = function (obj) {
    /// <summary>
    /// This function adds or deletes a single entry which is moved between the two connected lists.
    /// </summary>
    var me = this;

    try {
        var source = obj.parents(".connect").attr("id");
        var target = "";
        if (source === "lstSource") {
            target = "lstTarget";
        }
        if (source === "lstTarget") {
            //stop if the item cannot get deleted
            if (obj.hasClass("notDelete")) {
                me.showMessage(me.resources.entryCannotGetDeleted, false);
                return false;
            }
            target = "lstSource";
        }
        me.showInfo("", "", false);

        if (typeof (obj[0].attributes["data-id"]) !== "undefined") {
            me.update(obj.parents(".connect").attr("id"), obj[0].attributes["data-id"].value);
        }
        var litem = obj.clone();
        litem.appendTo(me.visual.find("#" + target));
        obj.remove();
        return true;
    } catch (ex) {
        me.writeError('manualUpdate', ex);
        return false;
    }

};


MSAssignment.prototype.update = function (source, id) {
    /// <summary>
    /// This function adds or deletes a single entry which is moved between the two connected lists.
    /// </summary>
    var me = this;
  
    try {
        if (me.error) { return false; }
        id = parseInt(id, 10);
        // add the entry if it comes from the source
        if (source === "lstSource") { me.save(1, id); }
        // delete the entry if it comes from the target
        if (source === "lstTarget") {me.save(2, id);}
        return true;
    } catch (ex) {
        me.writeError('update', ex);
        return false;
    }

};

MSAssignment.prototype.save = function (type, id) {
    /// <summary>
    /// This function takes an entry id, hides the entry, sends the id to the server for deleting and updates the sorting.
    /// </summary>
    var me = this;
   
    try {
        if (me.error) { return false; }

        window.VisualCoreService.updateData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, me.parameter, '', me.deviceType, me.langid, JSON.stringify({ 'type': type, 'LoggerId': me.blid, 'id': id, 'assID': me.assID }),
            function (result) {
                if (result !== true) {
                    me.showMessage(me.resources.err_saveData, true);
                    return false;
                }
                if (me.VCMQ_update_message.length > 0) {
                    _VCMQ.produce(me.visual, me.vcgid, me.VCMQ_update_message, '');
                }

                return true;
            });

        return true;
    } catch (ex) {
        me.writeError('save', ex);
        return false;
    }

};

MSAssignment.prototype.initFilterInput = function (obj, list) {
    /// <summary>
    ///  This function inits the change event handlers for one single filter input 
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }
        ////init the filter events
        obj.off('keyup').on('keyup', function (e) {
            me.filter(obj, list); e.stopPropagation();
        });
        obj.off('change').on('change', function (e) {
            me.filter(obj, list); e.stopPropagation();
        });

        return true;
    } catch (ex) {
        me.writeError('initFilterInput', ex);
        return false;
    }

};

MSAssignment.prototype.filter = function (obj, list) {
    /// <summary>
    ///  This function shows/hides items of the given list. 
    /// </summary>
    var me = this;
    var filter = "";
    try {
        if (me.error) { return false; }
        //get filter expressions
        if (obj.val().trim().length > 0) { filter = obj.val().trim(); }

        if (filter.length > 0) {
            list.find(".vc-list-item").hide();
            list.find(".vc-list-item:contains('" + filter + "')").show();
        } else {
            list.find(".vc-list-item").show();
        }

        return true;
    } catch (ex) {
        me.writeError('filter', ex);
        return false;
    }

};

MSAssignment.prototype.specificInfoHandling = function (bError) {
    /// <summary>
    /// This function  hides/fades out content on error state. 
    /// </summary>
    var me = this;
    try {
        if (bError) {
            me.visual.find('#divEntry, #divSource, #divTarget').hide();
        }
        return true;
    } catch (ex) { me.writeError('specificInfoHandling', ex);
        return false;
    }
};



function MSAssignmentTags() {
    /// <summary>
    /// This object provides js functions for the Widget.Assigment.* <br/>
    /// <br/>
    /// Author: ARF<br />
    /// Date: 11.5.2016<br />
    /// Copyright ©: EUDT GmbH 2016 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.1 - 10.08.2016   (MWI)                                      *<br />
    /// **********************************************************************<br />
    /// * -added functions addAssignmentItemSpecifics, loadFirstInList and addSpecificClickHandler               *<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 11.5.2016                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>

}

MSAssignmentTags.prototype = new MSAssignment();

MSAssignmentTags.prototype.loadItems = function (id) {
    /// <summary>
    /// This function loads all entries for the selected item and fills the sortable lists 
    /// </summary>
    var me = this;
    var sTmp;
    var sTmpSrc;
    var type = "";
    try {
        if (me.error) { return false; }
       
        me.assID = id;
        me.visual.find("#lstSource").html(me.vcC.getLoadingIcon());
        window.VisualCoreService.getData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, me.parameter, '', me.deviceType, me.langid, JSON.stringify({ 'type': 1, 'LoggerId': me.blid, 'id': id, 'assID': me.assID }),
            function (result) {
                if (result === null) {
                    me.showMessage(me.resources.err_saveData, true);
                    return false;
                }
                if (result.rows === null) {
                    me.showMessage(me.resources.err_saveData, true);
                    return false;
                }
                me.visual.find("#lstSource, #lstTarget").html("");
                for (var i = 0; i < result.rows.length; i++) {
                    sTmp = "";
                    sTmpSrc = "";
                    if (result.rows[i].foundid === null) {
                        if (type !== result.rows[i].prefix) {
                            sTmpSrc = "<div class='button-default' style='padding:5px'>" + result.rows[i].prefix + "</div>";
                            type = result.rows[i].prefix;
                        }
                    }
                    sTmp = "<li class='vc-list-item ui-widget-content";
                    if (result.rows[i].active === false) { sTmp += " inactive" }
                    if (result.rows[i].delete === false) { sTmp += " notDelete" }
                    if (result.rows[i].staff === true) { sTmp += " staff" }
                    sTmp += "' data-id='" + result.rows[i].id + "' data-tagid='" + result.rows[i].id + "'>";
                    sTmp += me.addAssignmentItemSpecifics(result.rows[i]);
                    if (result.rows[i].delete === false) { sTmp += "<i class='fa fa-ban'></i> " }
                    if (result.rows[i].staff) { sTmp += "<i class='fa fa-users'></i> " }
                    sTmp += result.rows[i].name;
                    sTmp += "</li>";

                    if (result.rows[i].foundid === null) {
                        me.visual.find("#lstSource").append(sTmpSrc + sTmp);
                    } else {
                        me.visual.find("#lstTarget").append(sTmp);
                    }
                }

                // apply priority tag blocking before initializing sortable
                me.applyPriorityTagBlocking();

                // init the refilled sortable source and target lists
                me.initSortable();
                me.filter(me.visual.find("#divSource #txtFilter"), me.visual.find("#divSource"));
                me.filter(me.visual.find("#divTarget #txtFilter"), me.visual.find("#divTarget"));

                return true;
            });

        return true;
    } catch (ex) {
        me.writeError('loadItems', ex);
        return false;
    }
};

MSAssignmentTags.prototype.getPriorityGroup = function (tagId) {
    /// <summary>
    /// Returns the priority group name for a given tag ID, or null if not a priority tag.
    /// Leaks group: 2717-2721, Plaus group: 2723-2726
    /// </summary>
    var id = parseInt(tagId);
    if (id >= 2717 && id <= 2721) return "Leaks";
    if (id >= 2723 && id <= 2726) return "Plaus";
    return null;
};

MSAssignmentTags.prototype.applyPriorityTagBlocking = function () {
    /// <summary>
    /// Checks if a priority tag group (Leaks or Plaus) is already assigned in lstTarget.
    /// If so, all remaining tags of that group in lstSource are greyed out and blocked.
    /// </summary>
    var me = this;
    try {
        // clear all existing blocks first
        me.visual.find("#lstSource .vc-list-item.priority-blocked").removeClass("priority-blocked inactive");

        var assignedGroups = {};

        // check which groups are already assigned in lstTarget
        me.visual.find("#lstTarget .vc-list-item").each(function () {
            var group = me.getPriorityGroup($(this).data("tagid"));
            if (group) { assignedGroups[group] = true; }
        });

        // block all source items belonging to an already assigned group
        me.visual.find("#lstSource .vc-list-item").each(function () {
            var group = me.getPriorityGroup($(this).data("tagid"));
            if (group && assignedGroups[group]) {
                $(this).addClass("priority-blocked inactive");
            }
        });
    } catch (ex) {
        me.writeError('applyPriorityTagBlocking', ex);
    }
};

MSAssignmentTags.prototype.initSortable = function () {
    /// <summary>
    /// Overrides the base initSortable to block dragging of priority-blocked items.
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }
        if (me.mobile) { return true; }

        me.visual.find("#lstSource,#lstTarget").sortable({
            connectWith: ".connect",
            tolerance: 'pointer', cursor: 'move', placeholder: "lstPlaceholder",
            cancel: ".priority-blocked",
            update: function (e, ui) {
                me.manualSorting(e);
                if (ui.sender !== null) {
                    if (typeof (ui.item[0].attributes["data-id"]) !== "undefined") {
                        me.update(ui.sender[0].id, ui.item[0].attributes["data-id"].value);
                    }
                }
                // re-evaluate blocking after every drag
                me.applyPriorityTagBlocking();
            }
        }).disableSelection();

        me.visual.find(".connect").off("dblclick", ".vc-list-item").on('dblclick', ".vc-list-item", function () {
            return me.manualUpdate($(this));
        });


        return true;
    } catch (ex) {
        me.writeError('initSortable', ex);
        return false;
    }
};

MSAssignmentTags.prototype.manualUpdate = function (obj) {
    /// <summary>
    /// Overrides the base manualUpdate to block moving priority-blocked items from lstSource.
    /// Re-evaluates blocking after every successful move.
    /// </summary>
    var me = this;
    try {
        // block if the item is priority-blocked and comes from lstSource
        if (obj.hasClass("priority-blocked") && obj.parents(".connect").attr("id") === "lstSource") {
            me.showMessage(me.resources.priorityTagAlreadyAssigned, false);
            return false;
        }

        var result = MSAssignment.prototype.manualUpdate.call(me, obj);

        // re-evaluate blocking after every successful move (also handles removal from lstTarget)
        me.applyPriorityTagBlocking();

        return result;
    } catch (ex) {
        me.writeError('manualUpdate', ex);
        return false;
    }
};